/**
 * Condições de uso.
 *
 * Documento estático. Está registrado no App Registration do Entra como
 * "Terms of service URL" e aparece na tela de consentimento da Microsoft —
 * mudar a URL exige pedido formal ao IAM (DEP-27), não é edição nossa.
 *
 * Revisão jurídica pendente.
 */
import { Link } from 'react-router-dom';
import { usePageMeta } from '../hooks/usePageMeta.js';
import { Header } from '../components/Header.jsx';
import { Panel } from '../components/Panel.jsx';

export function Terms() {
  usePageMeta('AI Hub — condições de uso');

  return (
    <>
      <Header badge="condições de uso" />

      <main>
        <h1>Condições de uso</h1>
        <p className="lead">
          O AI Hub é uma ferramenta interna da Iguatemi, mantida pela equipe de Inovação e IA. O uso
          é restrito a colaboradores com conta corporativa ativa.
        </p>

        <Panel
          title="O que a plataforma é"
          footer="O AI Hub não substitui os sistemas do portfólio nem altera as regras de acesso deles. Ele organiza a porta de entrada."
        >
          <p className="lead">
            Um catálogo dos agentes de IA e sistemas disponíveis na companhia. Você vê o que existe,
            abre o que já tem permissão de usar e solicita acesso ao resto — a solicitação abre um
            chamado no ServiceNow e segue o fluxo normal de aprovação.
          </p>
        </Panel>

        <Panel title="Ao usar, você concorda em">
          <ul className="checks">
            <li>Não compartilhar sua sessão nem suas credenciais com terceiros.</li>
            <li>Usar os acessos concedidos apenas para finalidades de trabalho.</li>
            <li>
              Não tentar contornar os controles de acesso da plataforma ou dos sistemas de destino.
            </li>
            <li>
              Tratar como confidencial a informação obtida através dos sistemas do portfólio,
              conforme as políticas internas da companhia.
            </li>
          </ul>
        </Panel>

        <Panel title="Registro de atividade">
          <p className="lead">
            Acessos e solicitações ficam registrados, com identificação de usuário e dados. O
            registro existe para auditoria e para dar rastreabilidade às concessões de acesso. O
            detalhamento está em <Link to="/privacidade">tratamento de dados</Link>.
          </p>
        </Panel>

        <Panel
          title="Disponibilidade"
          footer="Documento interno, mantido junto do código da plataforma. Revisão jurídica pendente."
        >
          <p className="lead">
            A plataforma é mantida em regime de melhor esforço pela equipe de Inovação e IA. Não há
            compromisso formal de disponibilidade, e o acesso pode ser suspenso a qualquer momento
            por necessidade de segurança ou manutenção.
          </p>
        </Panel>
      </main>
    </>
  );
}
